/**
 * @generated SignedSource<<e064f3882430fafd494ad9f0bb9a670d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoDetailTeams_todo$data = {
  readonly teams: ReadonlyArray<{
    readonly name: string;
  }>;
  readonly " $fragmentType": "TodoDetailTeams_todo";
};
export type TodoDetailTeams_todo$key = {
  readonly " $data"?: TodoDetailTeams_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoDetailTeams_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoDetailTeams_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "5edd96d71b64f29fc3f7ede07d9dd320";

export default node;
